/* RevitalGlow custom cart drawer.
   Watches cart requests (theme, Kaching, anything else) and repaints from the
   rg-cart section. Optimistic updates, no polling, no price scraping. */
(function () {
  if (window.__rgCartInit) return;
  window.__rgCartInit = true;

  var SECTION = 'rg-cart';
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  var root, body, countEl, totalEl, protectionEl;
  var lastFocused = null;
  var busy = false;
  var paintSeq = 0; /* only the newest response may paint */
  var pendingOpen = false; /* open the drawer once fresh contents are painted */
  var pendingTimer = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function cache() {
    root = document.getElementById('rg-cart');
    if (!root) return false;
    body = $('[data-rg-body]', root);
    countEl = $('[data-rg-count]', root);
    totalEl = $('[data-rg-checkout-total]', root);
    protectionEl = $('[data-rg-protection]', root);
    return true;
  }

  /* Empty cart shows the header and message only: no progress bar, no footer */
  function setEmpty(isEmpty) {
    if (root) root.classList.toggle('rg-cart--empty', !!isEmpty);
  }

  /* ---------- open / close ---------- */

  function open() {
    if (!root || root.classList.contains('rg-cart--open')) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('rg-cart--open'); });
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.rg-cart__close', root);
    if (closeBtn) closeBtn.focus();
    document.dispatchEvent(new CustomEvent('rg-cart:open'));
  }

  function close() {
    if (!root) return;
    root.classList.remove('rg-cart--open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    document.dispatchEvent(new CustomEvent('rg-cart:close'));
  }

  /* After an add: paint the new contents first, then open, so the drawer never
     flashes the old (empty) cart. Opens anyway if the store is slow to answer. */
  function openFresh() {
    if (!root) return;
    if (root.classList.contains('rg-cart--open')) { refresh(); return; }
    pendingOpen = true;
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(function () {
      if (!pendingOpen) return;
      pendingOpen = false;
      if (body && !body.querySelector('.rg-item')) body.innerHTML = '<div class="rg-cart__empty">Updating your cart&hellip;</div>';
      open();
    }, 1500);
    refresh();
  }

  /* ---------- painting ---------- */

  function syncThemeCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .site-header__cart-count');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    for (var j = 0; j < bubbles.length; j++) {
      bubbles[j].classList.toggle('cart-link__bubble--visible', count > 0);
    }
  }

  function paint(html, seq) {
    if (seq !== undefined && seq !== paintSeq) return; /* stale response */
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var data = doc.getElementById('rg-cart-data');
    if (!data || !body) return;

    body.innerHTML = data.innerHTML;

    var count = parseInt(data.getAttribute('data-count'), 10) || 0;
    var protectionOn = data.getAttribute('data-protection') === 'true';

    if (countEl) countEl.textContent = count;
    if (totalEl) totalEl.textContent = data.getAttribute('data-total') || '';
    if (protectionEl) {
      protectionEl.checked = protectionOn;
      protectionEl.disabled = false;
    }

    var checkout = $('[data-rg-checkout]', root);
    if (checkout) checkout.disabled = count === 0;
    setEmpty(count === 0);
    syncThemeCount(count);

    if (pendingOpen) {
      pendingOpen = false;
      window.clearTimeout(pendingTimer);
      open();
    }

    /* never leave protection alone in the cart */
    if (count === 0 && protectionOn) setProtection(false);
  }

  function refresh() {
    if (!root) return Promise.resolve();
    var seq = ++paintSeq;
    var url = '/?sections=' + SECTION + '&_=' + Date.now();
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (json) { paint(json[SECTION] || '', seq); })
      .catch(function () {});
  }

  /* ---------- cart writes ---------- */

  function postCart(path, payload, seq) {
    return fetch(path + '?rg=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.sections && json.sections[SECTION]) paint(json.sections[SECTION], seq);
        else return refresh();
      })
      .catch(function () { return refresh(); });
  }

  function optimistic(row, quantity) {
    if (!row) return;
    if (quantity === 0) {
      row.remove();
      if (!body.querySelector('.rg-item')) {
        var msg = (window.theme && theme.strings && theme.strings.cartEmpty) || 'Your cart is currently empty.';
        body.innerHTML = '<div class="rg-cart__empty">' + msg + '</div>';
        setEmpty(true);
      }
    } else {
      var input = $('[data-rg-input]', row);
      if (input) input.value = quantity;
    }
  }

  function changeLine(key, quantity, row) {
    if (busy || !key) return;
    busy = true;
    optimistic(row, quantity);
    var seq = ++paintSeq;
    postCart('/cart/change.js', { id: key, quantity: quantity, sections: SECTION }, seq)
      .then(function () { busy = false; });
  }

  /* Package Protection toggle: adds or removes the protection product.
     /cart/change.js only accepts the id as a string (a number is rejected with 400). */
  function setProtection(on) {
    if (!protectionEl) return;
    var variantId = protectionEl.getAttribute('data-rg-variant');
    if (!variantId) return;
    protectionEl.disabled = true;
    var seq = ++paintSeq;
    var done = function () { protectionEl.disabled = false; };
    if (on) {
      postCart('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: SECTION }, seq).then(done);
    } else {
      postCart('/cart/change.js', { id: String(variantId), quantity: 0, sections: SECTION }, seq).then(done);
    }
  }

  function rowOf(el) { return el.closest('.rg-item'); }
  function lineKeyOf(el) { var r = rowOf(el); return r ? r.getAttribute('data-rg-line') : null; }
  function qtyOf(el) {
    var r = rowOf(el);
    var input = r ? $('[data-rg-input]', r) : null;
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  /* ---------- events ---------- */

  function bind() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-rg-close]')) { e.preventDefault(); close(); return; }
      if (t.closest('[data-rg-checkout]')) { e.preventDefault(); window.location.href = '/checkout'; return; }

      var minus = t.closest('[data-rg-minus]');
      if (minus) { e.preventDefault(); changeLine(lineKeyOf(minus), Math.max(0, qtyOf(minus) - 1), rowOf(minus)); return; }

      var plus = t.closest('[data-rg-plus]');
      if (plus) { e.preventDefault(); changeLine(lineKeyOf(plus), qtyOf(plus) + 1, rowOf(plus)); return; }

      var remove = t.closest('[data-rg-remove]');
      if (remove) { e.preventDefault(); changeLine(lineKeyOf(remove), 0, rowOf(remove)); return; }

      var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], .js-drawer-open-cart, [data-rg-open]');
      if (cartLink && !t.closest('#rg-cart')) {
        e.preventDefault();
        e.stopPropagation();
        open();
        refresh();
      }
    }, true);

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.matches('[data-rg-protection]')) { setProtection(target.checked); return; }

      var input = target.closest('[data-rg-input]');
      if (input) changeLine(lineKeyOf(input), Math.max(0, parseInt(input.value, 10) || 0), rowOf(input));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) close();
    });
  }

  /* ---------- watch cart mutations from any source ---------- */

  function watchRequests() {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mine = url.indexOf('rg=1') !== -1;
        var isMutation = !mine && MUTATION_RE.test(url);
        var isAdd = isMutation && /\/cart\/add/i.test(url);
        return origFetch.apply(this, arguments).then(function (res) {
          if (isMutation) {
            if (isAdd) openFresh();
            else refresh();
          }
          return res;
        });
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__rgUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__rgUrl || '';
      if (url.indexOf('rg=1') === -1 && MUTATION_RE.test(url)) {
        xhr.addEventListener('load', function () {
          if (/\/cart\/add/i.test(url)) openFresh();
          else refresh();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function init() {
    if (!cache()) return;
    bind();
    watchRequests();
    var count = parseInt(countEl && countEl.textContent, 10) || 0;
    var checkout = $('[data-rg-checkout]', root);
    if (checkout) checkout.disabled = count === 0;
    setEmpty(count === 0);
    window.rgCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();